//eslint:disable max-func-body-length
import * as React from 'react';
import { OptionsProps } from 'app/components/options-handler';
import { CodetableMetadata } from 'app/area/codetable/types-store';
import { CodeComplexValue } from 'app/area/shared/codetable/types';
import { Translations } from 'app/area/codetable/item/translation/translations';
import { ValidationProps } from 'ui/common/validation/types';
import { Component, RefObject } from 'react';
import { CodeEditSectionType, CodeActionType, ScreenSlots, Slot, ReadOnlyConfiguration } from 'app/area/codetable/item/types';
import { withMetroLine } from 'app/components/metro-line/with-metro-line';
import { WithMetroLineProps, WithMetroLineWrappedComponentProps } from 'app/components/metro-line/types';
import { MetroLineSection } from 'app/components/metro-line/metro-line-section';
import { CodeItem } from 'app/area/codetable/item/types-store';
import { CodetableTranslation } from 'app/area/codetable/constants';
import { CodetableOptions } from 'app/area/codetable/common';
import { actionCreators } from 'app/area/codetable/item/actions';
import styles from '../../screen-template.scss';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { UomConversion } from 'app/area/codetable/item/uom-conversion/uom-conversion';
import { Visibility } from 'app/area/codetable/item/visibility/visibility';
import { UnitOfMeasureDetails } from 'app/area/codetable/item/screen-renderer/screen-sections/unit-of-measure/unit-of-measure-details';

export interface UomTemplateExternalProps extends WithMetroLineProps<CodeEditSectionType> {
  screenPayload: ScreenSlots;
  codetableId: number;
  section: string;
  actionType: CodeActionType;
  codeItem: CodeItem;
  originalCodeItem: CodeItem;
  metadata: CodetableMetadata;
  language: CodeComplexValue<number>;
  locale: string;
  translation: CodetableTranslation;
  hasTranslationsToggled: boolean;
  codetableOptions: { [key: string]: CodetableOptions };
  validation: { [key: string]: ValidationProps };
  sectionRef?: RefObject<HTMLDivElement>;
  hasBigStickyHeader?: boolean;
  readOnly?: boolean;
  readOnlyConfig?: ReadOnlyConfiguration;
  fetchingIsUomExcludedCheck?: boolean;
  isUomExcluded?: boolean;
  [key: string]: any;
}

export type UomTemplateProps = UomTemplateExternalProps & OptionsProps
  & typeof actionCreators & WithMetroLineProps<CodeEditSectionType> & WithMetroLineWrappedComponentProps<CodeEditSectionType>;

class UomScreenTemplate extends Component<UomTemplateProps> {

  private getSectionSlot = (section: CodeEditSectionType): Slot =>
    this.props.screenPayload ? this.props.screenPayload[section] : undefined;

  public render() {
    const {
      metadata, language, switchTranslationsToggle, getRef, hasBigStickyHeader, copyDescriptionToAllTranslations,
      copyLongDescriptionToAllTranslations, updateDescription, updateLongDescription, actionType, codeItem
    } = this.props;

    const renderTranslationsOnTop = actionType === CodeActionType.Duplicate || shouldRenderTranslationsOnTop(codeItem);

    return <div className={styles.screenTemplate}>
      <div>
        {renderTranslationsOnTop && <MetroLineSection<CodeEditSectionType>
          {...this.props}
          sectionType={CodeEditSectionType.Translations}
          hasBigStickyHeader={hasBigStickyHeader}>
          <Translations
            sectionRef={getRef(CodeEditSectionType.Translations)}
            {...this.props}
            metadata={metadata}
            mainLanguage={language}
            copyDescriptionToAllTranslations={copyDescriptionToAllTranslations}
            copyLongDescriptionToAllTranslations={copyLongDescriptionToAllTranslations}
            switchTranslationsToggle={switchTranslationsToggle}
            onDescriptionChange={updateDescription}
            onLongDescriptionChange={updateLongDescription}
          />
        </MetroLineSection>
        }
        <MetroLineSection<CodeEditSectionType>
          {...this.props}
          sectionType={CodeEditSectionType.Details}
          hasBigStickyHeader={hasBigStickyHeader}
        >
          <UnitOfMeasureDetails
            sectionRef={getRef(CodeEditSectionType.Details)}
            sectionSlots={this.getSectionSlot(CodeEditSectionType.Details)}
            {...this.props}
          />
        </MetroLineSection>

        <MetroLineSection<CodeEditSectionType>
          {...this.props}
          sectionType={CodeEditSectionType.UomConversion}
          hasBigStickyHeader={hasBigStickyHeader}
        >
          <UomConversion
            sectionRef={getRef(CodeEditSectionType.UomConversion)}
            sectionSlots={this.getSectionSlot(CodeEditSectionType.UomConversion)}
            {...this.props}
          />

        </MetroLineSection>

        <MetroLineSection<CodeEditSectionType>
          {...this.props}
          sectionType={CodeEditSectionType.Visibility}
          hasBigStickyHeader={hasBigStickyHeader}
        >
          <Visibility
            sectionRef={getRef(CodeEditSectionType.Visibility)}
            sectionSlots={this.getSectionSlot(CodeEditSectionType.Visibility)}
            {...this.props}
          />

        </MetroLineSection>

        {!renderTranslationsOnTop && <MetroLineSection<CodeEditSectionType>
          {...this.props}
          sectionType={CodeEditSectionType.Translations}
          hasBigStickyHeader={hasBigStickyHeader}
        >
          <Translations
            sectionRef={getRef(CodeEditSectionType.Translations)}
            {...this.props}
            metadata={metadata}
            mainLanguage={language}
            copyDescriptionToAllTranslations={copyDescriptionToAllTranslations}
            copyLongDescriptionToAllTranslations={copyLongDescriptionToAllTranslations}
            switchTranslationsToggle={switchTranslationsToggle}
            onDescriptionChange={updateDescription}
            onLongDescriptionChange={updateLongDescription}
          />
        </MetroLineSection>
        }
      </div>
    </div >;
  }
}

export const UomTemplate = withMetroLine<UomTemplateExternalProps, CodeEditSectionType>()(UomScreenTemplate);

const shouldRenderTranslationsOnTop = (codeItem: CodeItem) => codeItem && !isDefinedIncludingZero(codeItem.id);
